import { motion } from 'framer-motion'
import styled, { css } from 'styled-components'

import { FlexCentered } from 'components/common/genericStyles'

import { tabDesktopBreakpoint } from '../constants'

export const Button = styled(motion.button)`
    background: #089864;
    border: 1.5px solid #000000;
    box-sizing: border-box;
    box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.75);
    border-radius: 12px;
    color: #ffffff;
    ${FlexCentered};
    padding: 12px 24px;
    cursor: pointer;
    ${({ $css, $loading }) => {
        return css`
            ${$loading && 'opacity: 0.7;'}
            ${$css}
        `
    }}
`

export const StopButtonWrapper = styled.div`
    position: absolute;
    left: 5.47%;
    top: 55%;
    z-index: 1;
    & > button {
        box-shadow: 6px 6px 0px rgba(0, 0, 0, 0.75);
        min-width: 153px;
        min-height: 56px;
    }

    @media only screen and (orientation: landscape) {
        top: 71%;
    }
    @media (min-width: ${tabDesktopBreakpoint}px) {
        top: 70%;
    }
`

export const StartButtonWrapper = styled.div`
    position: absolute;
    left: 9.8%;
    top: 52.16%;
    & > button {
        box-shadow: 6px 6px 0px rgba(0, 0, 0, 0.75);
        min-width: 212px;
        min-height: 56px;
    }
`

export const QuizChoice = {
    Area: styled(motion.button)`
        ${FlexCentered}
        justify-content: flex-start;
        padding: 20px;
        border-radius: 8px;
        width: 100%;
        cursor: pointer;

        ${props => {
            const { isSelected } = props

            const border = isSelected ? 'none' : '1px solid #000000'
            const boxShadow = isSelected
                ? 'none'
                : '4px 4px 0px rgba(0, 0, 0, 0.75)'
            const bgColor = isSelected ? 'rgba(0, 0, 0, 0.12)' : 'transparent'

            return css`
                background-color: ${bgColor};
                box-shadow: ${boxShadow};
                border: ${border};
            `
        }}
    `,
    Option: styled.div`
        span {
            font-size: 12px;
            color: rgba(0, 0, 8, 0.3);
        }

        /* Tablets & up */
        @media (min-width: ${tabDesktopBreakpoint}px) {
            width: 30px;
            text-align: left;
            span {
                font-size: 16px;
            }
        }
    `,
    Content: styled.div`
        margin-left: 5px;
        span {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.86);
        }

        /* Tablets & up */
        @media (min-width: ${tabDesktopBreakpoint}px) {
            span {
                font-size: 20px;
            }
        }
    `,
}

export const NextQuestionButtonWrapper = styled.div`
    position: absolute;
    right: 1.5vw;
    top: 2.83vh;
    & > button {
        min-width: 84px;
        min-height: 39px;
    }
`
